import styled from "styled-components";
import { theme } from "../../theme/semanticTheme";

const bp = theme.breakpoints || { md: "768px", sm: "640px" };

/**
 * Glassmorphism container – theme light gradient; not scrollable; inner content scrolls.
 */
export const PageContainerWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: ${theme.spacing.xl};
  @media (max-width: ${bp.md}) {
    padding: ${theme.spacing.lg};
  }
  @media (max-width: ${bp.sm}) {
    padding: ${theme.spacing.md};
  }
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.85) 0%,
    ${theme.colors.backgroundAlt} 40%,
    ${theme.colors.accentLight} 100%
  );
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: ${theme.borderRadius.lg};
  border: 1px solid rgba(57, 0, 149, 0.12);
  box-shadow:
    0 8px 32px rgba(57, 0, 149, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);

  &.page-container-welcome {
    background: transparent;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border: none;
    box-shadow: none;
    padding: 0;
  }
`;

/** Inner scrollable area – only this part scrolls, not the morphism container. */
export const PageContainerScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;
